import React from 'react';
import './ApplyToRUK.css';
import Navbar from '../../components/Homepage/Navbar/Navbar';
import Footer from '../../components/Homepage/Footer/Footer';

const ApplyToRUK = () => {
  return (
    <div id="apply-page" className="page-wrapper">
      <Navbar />
      <main id="apply-content" className="page-container light-theme">
        <div id="apply-container" className="container">
          <header id="apply-header" className="page-header">
            <h1>Apply to Rayalseema University Kurnool</h1>
            <p className="header-subtitle">Begin your academic journey with one of India's premier institutions</p>
          </header>

          <section id="required-documents" className="documents">
            <h2>Required Documents</h2>
            <div id="document-grid" className="document-list">
              <div id="doc-1" className="document-item">📄 Class X Mark Sheet</div>
              <div id="doc-2" className="document-item">📄 Class XII Mark Sheet</div>
              <div id="doc-3" className="document-item">📄 Transfer Certificate</div>
              <div id="doc-4" className="document-item">📄 Migration Certificate</div>
              <div id="doc-5" className="document-item">📄 Character Certificate</div>
              <div id="doc-6" className="document-item">📄 ID Proof</div>
            </div>
          </section>

          <button id="apply-cta" className="apply-button">
            Start Your Application
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ApplyToRUK;
